<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <!-- 菜单 -->
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.module.scss";

export default {
  components: { SidebarItem, Logo },
  mounted() {
  },
  computed: {
    ...mapGetters(["sidebar"]),
    routes() {
      let userInfo = JSON.parse(localStorage.getItem("consoleuserinfoTypeResult") || "{}");
      let userRole = userInfo.role || "";
      
      let adminOnlyPaths = ["/class", "/user", "/equipment", "/teacher"];
      let orgAdminCanSee = ["/"];
      
      if (userRole === "系统操作管理员") {
        return this.$router.options.routes;
      } else if (userRole === "合作伙伴管理员") {
        return this.$router.options.routes.filter((item) => {
          if (adminOnlyPaths.includes(item.path)) {
            return false;
          }
          return true;
        });
      } else {
        return this.$router.options.routes.filter((item) => {
          if (adminOnlyPaths.includes(item.path) || orgAdminCanSee.includes(item.path)) {
            return false;
          }
          return true;
        });
      }
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
};
</script>
